<script setup lang="ts">
import FavoriteProducts from '@/components/about-us/our-family/FavoriteProducts.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header4 from '@/components/base/typography/Header4.vue';

const favoriteProducts = [
  {
    name: 'Jumbo Roasted Peanuts (In Shell)',
    url: '/nuts/peanuts/jumbo-roasted-inshell.html',
  },
  {
    name: 'Roasted Pistachios (Salted, In Shell)',
    url: '/nuts/pistachios/roasted-and-saltedinshell.html',
  },
  {
    name: 'Roasted Cashews (Salted)',
    url: '/nuts/cashews/roasted-and-salted.html',
  },
  {
    name: 'Turkish Figs',
    url: '/driedfruit/figs/turkish.html',
  },
  {
    name: 'English Walnuts (Raw, No Shell)',
    url: '/nuts/walnuts/english-no-shell.html',
  },
  {
    name: 'Dried Apricots',
    url: '/driedfruit/apricots/jumbo.html',
  },
  {
    name: 'Tart Cherries',
    url: '/driedfruit/cherries/sour-tart.html',
  },
  {
    name: 'Whole Dried Cranberries',
    url: '/driedfruit/cranberries/whole.html',
  },
  {
    name: 'Chocolate Raisins',
    url: '/driedfruit/raisins/chocolate.html',
  },
  {
    name: 'Dark Chocolate Covered Espresso Beans',
    url: '/chocolatessweets/moregoodies/darkchocolate-espresso-beans.html',
  },
];
</script>

<template>
  <div>
    <Header4 headerTag="h3">Sandy</Header4>
    <BaseBodyText>
      <strong>Hi! I'm Sandy.</strong> Uncle Sandy too. From around the time I could walk, I remember
      coming to work with my Dad and sitting on a wooden milk crate in the back of his 3 speed
      International truck. The ride to work would be like a taxi ride, and I hated it, as we had to
      pick up all of the employees along the way. As I got older I would leave school and go down to
      the store and work until we closed, and of course work every weekend. On Fridays we would work
      until 9 or 9:30 PM and be back to work at 5:30 AM the next morning. My only reprieve from work
      would be during high school football season when I had practices and games. When I graduated
      from high school my father had very little help at the store, so I ended up working full time
      and going to college at night.
    </BaseBodyText>

    <BaseBodyText>
      Our original store on Mulberry Street was housed in a building from the mid 1800s and did not
      have any heat. During the winter, heat would come from the peanut roaster, and we couldn't
      wait for the hot peanuts to come out to warm up. Back then the store spread into the outdoor
      market and we would practically freeze during the winter. The only other heat in the store
      would come from when my dad would roast up sweet potatoes on a small gas stove for all of the
      employees to eat. Boy did we love that!
    </BaseBodyText>

    <BaseBodyText>
      My Dad was well known throughout Newark as the unofficial Mayor of Mulberry Street. On any
      given busy day he would hold court with local lawyers, politicians, and doctors. His customers
      would sit down, visit the store for hours, and customers became friends. It brings tears to my
      eyes as his customers' children continue to visit us, as I remember their parents as a small
      boy.
    </BaseBodyText>

    <BaseBodyText>
      Through the countless hours of working with my dad and listening to his conversations, the
      most important thing I learned was that you can not try and fool the customers. Customers
      always want and are entitled to the freshest, best tasting, and highest quality products
      available. This was his secret to keeping customers coming back generation after generation.
      Remember, he was 22 when he started and worked until he was 88.
    </BaseBodyText>

    <BaseBodyText>
      As I grew up in the business, so did my role. I soon took over the buying from my dad. Just as
      my father did, I sought only the freshest, largest, and highest quality nuts and dried fruits.
      I started visiting our growers across the country in places such as California, Georgia, and
      Virginia. Today, I am in constant search of new and unique products. Some of our hallmark
      products that I am quite proud of are our whole dried cranberries, giant filberts in the
      shell, and super jumbo peanuts in the shell.
    </BaseBodyText>

    <BaseBodyText>
      I am also proud to see my son and nephew as the 3rd generation of our family business. I know
      my dad would be very happy and proud to see how much we have expanded and grown through the
      years.
    </BaseBodyText>
    <FavoriteProducts :favoriteProducts>
      I like playing golf, watching hockey (New York Rangers), watching baseball, cooking, eating in
      fine restaurants, swimming, body surfing, and traveling.
    </FavoriteProducts>
  </div>
</template>
